
const main_queue: (() => void)[] = [];
let main_iterator: number = 0;


/**
 * Invokes a specified function before return a specified value
 * @param action action to be invoked
 */
export function commit<T>(action: () => void): { return: (value: T) => T } {

  return {
    return: (value: T) => {
      action();
      return value;
    }
  }
}

/**
 * Invokes a specified function on the main thread.
 * @param fn function to be invoked on main thread.
 */
export function main(fn: () => void) {

  let iterator = ++main_iterator;
  main_queue.push(fn);

  requestAnimationFrame(() => {
    while (main_iterator == iterator && main_queue.length > 0) main_queue.shift()();
  });
}

const encodeHtmlContent_container = document.createElement('span');

export function encodeHtmlContent(value: string): string {
  encodeHtmlContent_container.innerText = value;
  return encodeHtmlContent_container.innerHTML;
}

export function decodeHtmlContent(value: string): string {
  encodeHtmlContent_container.innerHTML = value;
  return encodeHtmlContent_container.innerText;
}

const MIME = {
  'xls': 'application/vnd.ms-excel',
  'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'html': 'text/html',
  'json': 'application/json',
  'pdf': 'application/pdf',
  'zip': 'application/zip'
}

export function download(filename: string, base64content: string, mime?: string) {

  let ext = !mime ? filename.split('.').last() : undefined;

  let a = document.createElement('a');
  a.href = 'data:' + (mime ? mime : MIME[ext] ? MIME[ext] : 'application/' + ext) + ';base64,' + base64content;

  a.download = filename;  
  a.click();
}

let nextGUID = 1;

export function GUID(): string {
  return 'guid-' + (nextGUID)++;
}
